<template>
  <div class="activity-wrap">
    <app-header />
    <div class="auto">
      <span class="btn-buy" @click="goUrl(113)"></span>
      <p class="info">
       高端指标双结合，监测大智慧DDE决策资金+AI资金线资金强度，筛选出资金异动量价齐升个股，双重智能选股策略，帮助投资者抓住投资机会。
      </p>
      <div class="con">
        <img src="../../assets/images/activity/activity202110/img1.png" alt="">
        <img src="../../assets/images/activity/activity202110/img2.png" alt="">
        <h2>两大资金指标</h2>
        <p>DDE决策<span>(限定资金净流入额)</span></p>
        <p>AI资金线<span>（监控近期主力资金活跃度异动情况）</span></p>
        <img src="../../assets/images/activity/activity202110/img3.png" alt="" class="mt">
        <img src="../../assets/images/activity/activity202110/img4.png" alt="" class="mt">
        <img src="../../assets/images/activity/activity202110/img5.png" alt="" class="mt">
      </div>
    </div>
  </div>
</template>
<script>
import AppHeader from "@/components/common/AppHeader.vue";
export default {
  components: {
    AppHeader,
  },
  data () {
    return {
      token: '',

    }
  },
  created() {
    var token = this.$route.query.token;
    if (token) {
      this.token = token;
    }
  },
  mounted() {

  },
  methods: {
    goUrl (key) {
      let routerDate;
      if (this.token) {
        routerDate = this.$router.resolve({name: 'ClientProduct', query: {token: this.token, pid: key}})
      } else {
        routerDate = this.$router.resolve({name: 'OrderConfirm', params:{productId: key,month:12}})
      }
      let {href} = routerDate
      window.open(href, "_blank")
    },
  }
}
</script>
<style lang="scss" scoped>
.activity-wrap{
  background: url(../../assets/images/activity/activity202110/bg.jpg) no-repeat center 100px #224ad2;
  padding-bottom: 110px;
  .auto{
    width: 1000px;
    margin: 0 auto;
  }
  .btn-buy{
    margin: 415px 0 190px 705px;
    display: block;
    width: 293px;
    height: 95px;
    cursor: pointer;
  }
  .info{
    font-size: 32px;
    color: #fff;
    line-height: 48px;
    margin: 0 35px 90px;
    height: 240px;
  }
  .con{
    position: relative;
    color: #fff;
    >img{
      display: block;
    }
    .mt{
      margin-top: 75px;
    }
    h2{
      position: absolute;
      left: 355px;
      top: 30px;
      font-size: 46px;
    }
    p{
      position: absolute;
      left: 92px;
      top: 215px;
      font-size: 38px;
      &:nth-of-type(2){
        top: 1090px;
      }
      span{
        font-size: 32px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/activity/activity202110.vue